import React from 'react';

export function NoPermissions() {
  return (
    <div className="flex flex-col flex-1 overflow-hidden px-6 w-full py-4 mx-auto font-effra">
      <div className="flex items-left flex-col w-full px-10 my-12">
        <h1 className="text-4xl font-bold mb-6">An account update may be required.</h1>
        <h2 className="text-2xl">
          Please contact our Client Services team for support at
          <a className="mx-1 font-bold" href="mailto:clientservices@teladoc.com">
            clientservices@teladoc.com
          </a>
          <br />
          or for immediate assistance please call{' '}
          <a className="mx-1 font-bold" href="tel:866-509-8954">
            (866) 509-8954
          </a>
          .
        </h2>
      </div>
    </div>
  );
}
